module.exports = __webpack_public_path__ + "img/制御工学3_2.ce44af09.png";